export default {
      id: "sentiment-client-positive-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#sentiment-client-positive-usage",
      toString: function () {
        return this.url;
      }
    }